export default __webpack_public_path__ + "static/media/gallery-wip-3D-model_00.c025a01c.jpg";